<nb-card>
  <nb-card-header>
    <div>Action Required</div>
    <div class="countdown">{{ timeout }}</div>
  </nb-card-header>

  <nb-card-body>
    <p>Your connection time is running out. Please, renew it in order to stay logged in and continue work.</p>
    <div class="action">
      <button nbButton size="small" status="success" disabled="false" (click)="refreshToken()">Stay Here</button>
    </div>
  </nb-card-body>
</nb-card>
